import { useEffect } from 'react';

const Chatbot = () => {
  useEffect(() => {
    const script1 = document.createElement('script');
    script1.src = "https://www.chatbase.co/embed.min.js";
    script1.async = true;
    script1.defer = true;
    script1.setAttribute("chatbotId", "op4VU5AkeIhrTyRKDOSgs");
    script1.setAttribute("domain", "www.chatbase.co");
    
    const script2 = document.createElement('script');
    script2.text = `
      window.embeddedChatbotConfig = {
        chatbotId: "op4VU5AkeIhrTyRKDOSgs",
        domain: "www.chatbase.co"
      };
    `;
    
    document.body.appendChild(script2);
    document.body.appendChild(script1);

    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);

  return null; // The chatbot script will render outside of the component itself.
};

export default Chatbot;
